<div class="t-popup popup-graphs" style='display: block;height:100%' *ngIf="pdf || pdfLoading">

    <div class="popup-close"></div>
    
    <div class="popup-frame" >
        <div class="popup-body">
            <h2 *ngIf="reportid">Lab Result</h2>
            <button class="btn" (click)="assignToExam()" *ngIf="assignable">Assign To This Exam</button>

            <div class="graphs-container" style="max-width: 98%">
                <embed *ngIf="! pdfLoading && pdf != null" [src]="pdf" type="application/pdf"
                        style='position: relative;width:70vw;height:80vh;z-index:10'>
                    <img *ngIf="pdfLoading" src="../../assets/images/Wedges.svg"
                        style='z-index:0;margin-left: auto;margin-right:auto;position: absolute;left: 0; right: 0;top: 40vh'>
            </div>
            <button type="button" class="popup-close-button" (click)="closed.emit(false)">Close</button>
        </div>
    </div>
</div>
